/** Generic names for the KINDS. Used when a named place has been deleted. */
export const STORAGE_LABEL = {
    fridge: "Fridge",
    freezer: "Freezer",
    pantry: "Cupboard",
    counter: "Counter",
    cool_dark: "Cool & dark",
    shelf: "Shelf",
    other: "Somewhere else",
};
/**
 * A glyph per kind, for picking a place at a glance.
 *
 * Keyed on the KIND, never on the name, because the name is the household's
 * ("Cupboard (green)") and only the kind is a thing we know something about.
 * Decorative by definition — every place these appear also shows its name, so
 * they are `aria-hidden` at the call site and nothing is carried by the glyph
 * alone. Unicode has no refrigerator, hence milk for the fridge and the ice
 * cube for the freezer: the contents are more recognisable than the appliance.
 */
export const STORAGE_ICON = {
    fridge: "🥛",
    freezer: "🧊",
    pantry: "🥫",
    counter: "🧺",
    cool_dark: "🌑",
    shelf: "📚",
    other: "📦",
};
/** How each kind reads when someone is choosing one. */
export const STORAGE_KIND_HINT = {
    fridge: "Cold",
    freezer: "Frozen",
    pantry: "Dry & dark",
    counter: "Room temp",
    cool_dark: "Cool & dark",
    shelf: "For things that don't go off",
    other: "Anywhere else",
};
/** How many days before expiry the check-in fires. */
export const PING_LEAD_DAYS = 2;
/**
 * Days past expiry before an unanswered item is presumed wasted.
 *
 * Not zero: a date is a guess with a safety margin baked in, most things are
 * fine the day after, and declaring waste too eagerly teaches the user the app
 * is wrong — after which they stop trusting the red cells entirely.
 */
export const PRESUMED_GRACE_DAYS = 1;
/** Which statuses belong on the disposal list. */
export const DISPOSED = new Set([
    "wasted",
    "presumed_wasted",
]);
/** Resolved = the user's answer is in, so it can count towards stats. */
export const RESOLVED = new Set([
    "consumed",
    "wasted",
    "presumed_wasted",
]);
//# sourceMappingURL=item.js.map